import React from 'react';
import { Modal, Button } from 'react-bootstrap';

interface ConfirmModalProps {
	show: boolean;
	title: string;
	message: string;
	confirmText?: string;
	cancelText?: string;
	variant?: string;
	onConfirm: () => void;
	onCancel: () => void;
}

const ConfirmModal: React.FC<ConfirmModalProps> = ({
	show,
	title,
	message,
	confirmText = 'Confirm',
	cancelText = 'Cancel',
	variant = 'danger',
	onConfirm,
	onCancel,
}) => {
	return (
		<Modal show={show} onHide={onCancel} centered>
			<Modal.Header closeButton>
				<Modal.Title>{title}</Modal.Title>
			</Modal.Header>
			<Modal.Body>{message}</Modal.Body>
			<Modal.Footer>
				<Button variant="secondary" onClick={onCancel}>{cancelText}</Button>
				<Button variant={variant} onClick={onConfirm}>{confirmText}</Button>
			</Modal.Footer>
		</Modal>
	);
};

export default ConfirmModal;
